module.exports = __webpack_public_path__ + "img/1.2ca68c05.jpg";